<template>
  <div>
    <Card dis-hover title="车队充值汇总">
      <!-- 总计数据卡片 -->
      <Row :gutter="16" style="margin-bottom: 20px;">
        <Col span="8">
          <Card class="stat-card">
            <div class="stat-content">
              <div class="stat-icon amount-icon">
                <Icon type="ios-trending-up" size="30" />
              </div>
              <div class="stat-info">
                <div class="stat-label">总充值金额</div>
                <div class="stat-value highlight">¥{{ Number(totalData.total_amount || 0).toLocaleString('zh-CN', {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}</div>
              </div>
            </div>
          </Card>
        </Col>
        <Col span="8">
          <Card class="stat-card">
            <div class="stat-content">
              <div class="stat-icon count-icon">
                <Icon type="ios-document" size="30" />
              </div>
              <div class="stat-info">
                <div class="stat-label">总充值笔数</div>
                <div class="stat-value">{{ Number(totalData.total_count || 0).toLocaleString('zh-CN') }} 笔</div>
              </div>
            </div>
          </Card>
        </Col>
        <Col span="8">
          <Card class="stat-card">
            <div class="stat-content">
              <div class="stat-icon company-icon">
                <Icon type="ios-people" size="30" />
              </div>
              <div class="stat-info">
                <div class="stat-label">涉及车队数</div>
                <div class="stat-value">{{ Number(totalData.company_count || 0).toLocaleString('zh-CN') }} 个</div>
              </div>
            </div>
          </Card>
        </Col>
      </Row>

      <Form ref="searchForm" :model="searchData" inline :label-width="70">
        <FormItem label="车队名称">
          <Input 
            v-model="searchData.company_name" 
            placeholder="请输入车队名称"
            clearable
            style="width: 180px"
          />
        </FormItem>
        <FormItem label="时间范围">
          <DatePicker 
            v-model="searchData.date_range" 
            type="datetimerange" 
            placement="bottom-end" 
            placeholder="选择日期范围（默认为今天）"
            format="yyyy-MM-dd HH:mm:ss"
            style="width: 320px"
            @on-change="handleDateRangeChange"
          ></DatePicker>
        </FormItem>
        <FormItem>
          <Button type="primary" @click="handleSearch">查询</Button>
          <Button @click="handleReset" style="margin-left: 10px">重置</Button>
          <Button type="success" icon="ios-download" @click="handleExport" :loading="exportLoading" style="margin-left: 10px">
            导出 Excel
          </Button>
        </FormItem>
      </Form>
    </Card>

    <Card style="margin-top: 20px;">
      <Table 
        :columns="tableColumn" 
        :data="tableData"
        :loading="loading"
        border
      ></Table>
      
      <Page 
        class="page"
        :total="total"
        :current="currentPage"
        :page-size="pageSize"
        show-total
        show-elevator
        show-sizer
        @on-change="handlePageChange"
        @on-page-size-change="handlePageSizeChange"
        @on-prev="handlePageChange"
        @on-next="handlePageChange"
      ></Page>
    </Card>

    <!-- 查看详情弹窗 -->
    <Drawer
      v-model="detailModal.show"
      title="充值明细"
      width="1000"
      :mask-closable="true"
    >
      <div class="detail-header" v-if="detailModal.data">
        <div class="header-row">
          <span class="header-label">车队名称：</span>
          <span class="header-value">{{ detailModal.data.company_name }}</span>
        </div>
        <div class="header-row">
          <span class="header-label">总充值金额：</span>
          <span class="header-value highlight">¥{{ Number(detailModal.data.total_amount || 0).toLocaleString('zh-CN', {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}</span>
        </div>
        <div class="header-row">
          <span class="header-label">充值次数：</span>
          <span class="header-value">{{ detailModal.data.recharge_count }} 次</span>
        </div>
      </div>
      
      <Divider>充值记录</Divider>
      
      <Table 
        :columns="detailColumns" 
        :data="detailData"
        :loading="detailLoading"
        border
        :max-height="detailMaxHeight"
      ></Table>
      
      <div class="drawer-footer" v-if="detailTotal > 0">
        <Page 
          :total="detailTotal"
          :current="detailCurrentPage"
          :page-size="detailPageSize"
          show-total
          show-elevator
          show-sizer
          @on-change="handleDetailPageChange"
          @on-page-size-change="handleDetailPageSizeChange"
        ></Page>
      </div>
    </Drawer>
  </div>
</template>

<script>
import XLSX from 'xlsx'

export default {
  name: "companyRechargeTotal",
  data() {
    return {
      searchData: {
        company_name: '', // 车队名称
        date_range: [] // 默认今天
      },
      totalData: {},
      tableData: [],
      loading: false,
      total: 0,
      currentPage: 1,
      pageSize: 10,
      detailModal: {
        show: false,
        data: null
      },
      detailColumns: [
        {
          title: '充值时间',
          key: 'add_time',
          align: 'center',
          width: 180
        },
        {
          title: '类型',
          key: 'type_name',
          align: 'center',
          width: 120,
          render: (h, params) => {
            const typeMap = {
              '系统充值': { text: '系统充值', color: '#2d8cf0' },
              '手动充值': { text: '手动充值', color: '#19be6b' },
              '批量充值': { text: '批量充值', color: '#ff9900' }
            }
            const config = typeMap[params.row.type_name] || { text: params.row.type_name || '未知', color: '#999' }
            return h('Tag', {
              props: { color: config.color }
            }, config.text)
          }
        },
        {
          title: '充值金额',
          key: 'amount',
          align: 'center',
          width: 130,
          render: (h, params) => {
            return h('span', {
              style: { color: '#19be6b', fontWeight: 'bold' }
            }, `¥${params.row.amount || '0.00'}`)
          }
        },
        {
          title: '已核销金额',
          key: 'verify_amount',
          align: 'center',
          width: 130,
          render: (h, params) => {
            const val = parseFloat(params.row.verify_amount) || 0
            return h('span', { style: { color: '#19be6b' } }, `¥${val.toFixed(2)}`)
          }
        },
        {
          title: '待核销金额',
          key: 'remain_unpaid_amount',
          align: 'center',
          width: 130,
          render: (h, params) => {
            const val = parseFloat(params.row.remain_unpaid_amount) || 0
            return h('span', { style: { color: '#2d8cf0', fontWeight: 'bold' } }, `¥${val.toFixed(2)}`)
          }
        },
        {
          title: '充值前余额',
          key: 'before_amount',
          align: 'center',
          width: 130,
          render: (h, params) => {
            return h('span', { style: { color: '#808695' } }, `¥${params.row.before_amount || '0.00'}`)
          }
        },
        {
          title: '充值后余额',
          key: 'after_amount',
          align: 'center',
          width: 130,
          render: (h, params) => {
            return h('span', { style: { color: '#19be6b', fontWeight: 'bold' } }, `¥${params.row.after_amount || '0.00'}`)
          }
        },
        {
          title: '操作人',
          key: 'operator_name',
          align: 'center',
          width: 100,
          render: (h, params) => {
            return h('span', params.row.operator_name || '')
          }
        },
        {
          title: '备注',
          key: 'remark',
          align: 'center',
          minWidth: 150,
          ellipsis: true
        }
      ],
      detailData: [],
      detailLoading: false,
      detailTotal: 0,
      detailCurrentPage: 1,
      detailPageSize: 100,
      detailMaxHeight: 500,
      exportLoading: false,
      tableColumn: [
        {
          title: '序号',
          type: 'index',
          align: 'center',
          width: 120
        },
        {
          title: '车队 ID',
          key: 'company_id',
          align: 'center',
          width: 200
        },
        {
          title: '车队名称',
          key: 'company_name',
          align: 'center',
          minWidth: 180,
          ellipsis: true
        },
        {
          title: '总充值金额',
          key: 'total_amount',
          align: 'center',
          width: 240,
          render: (h, params) => {
            return h('span', {
              style: { color: '#19be6b', fontWeight: 'bold' }
            }, `¥${params.row.total_amount || '0.00'}`)
          }
        },
        {
          title: '充值次数',
          key: 'recharge_count',
          align: 'center',
          width: 180
        },
        {
          title: '已核销金额',
          key: 'verify_amount',
          align: 'center',
          width: 160,
          render: (h, params) => {
            const val = parseFloat(params.row.verify_amount) || 0
            return h('span', { style: { color: '#19be6b' } }, `¥${val.toFixed(2)}`)
          }
        },
        {
          title: '剩余待核销金额',
          key: 'remain_unpaid_amount',
          align: 'center',
          width: 160,
          render: (h, params) => {
            const val = parseFloat(params.row.remain_unpaid_amount) || 0
            return h('span', { style: { color: '#2d8cf0', fontWeight: 'bold' } }, `¥${val.toFixed(2)}`)
          }
        },
        {
          title: '操作',
          key: 'action',
          align: 'center',
          width: 220,
          render: (h, params) => {
            return h('Button', {
              props: {
                type: 'primary',
                size: 'small'
              },
              on: {
                click: () => {
                  this.viewDetail(params.row)
                }
              }
            }, '查看详情')
          }
        }
      ]
    }
  },
  methods: {
    async getTotalData() {
      this.loading = true
      try {
        let params = {
          page: this.currentPage,
          page_size: this.pageSize
        }
        
        // 添加车队名称参数
        if (this.searchData.company_name) {
          params.company_name = this.searchData.company_name.trim()
        }
        
        if (this.searchData.date_range && Array.isArray(this.searchData.date_range) && this.searchData.date_range.length === 2) {
          // 格式化日期对象为字符串
          const startDate = this.searchData.date_range[0]
          const endDate = this.searchData.date_range[1]
          
          // 开始时间：设置为当天的 00:00:00
          const start = new Date(startDate)
          start.setHours(0, 0, 0, 0)
          params.start_date = this.formatDateToString(start)
          
          // 结束时间：强制设置为当天的 23:59:59
          const end = new Date(endDate)
          end.setHours(23, 59, 59, 999)
          params.end_date = this.formatDateToString(end)
        }
        
        console.log('请求参数:', params) // 调试用
        
        // 调用总计接口获取汇总数据
        let totalRes = await this.$commonFun.postProxy('admin/finance/getCompanyRechargeTotal', params)
        console.log('总计接口返回:', totalRes) // 调试用
        this.$commonFun.dealApiResult(totalRes, () => {
          // 后端返回的数据结构适配
          this.totalData = {
            total_amount: totalRes.data.total_amount || 0,
            total_count: totalRes.data.total_count || 0,
            company_count: totalRes.data.company_count || 0,
            start_time: totalRes.data.start_time || '',
            end_time: totalRes.data.end_time || ''
          }
        })
        
        // 调用列表接口获取车队明细数据
        let listRes = await this.$commonFun.postProxy('admin/finance/getCompanyRechargeList', params)
        console.log('列表接口返回:', listRes) // 调试用
        this.$commonFun.dealApiResult(listRes, () => {
          this.tableData = listRes.data || []
          this.total = listRes.count || 0
        })
      } catch (error) {
        console.error('获取充值汇总数据失败:', error)
      } finally {
        this.loading = false
      }
    },
    
    handleSearch() {
      this.currentPage = 1
      this.getTotalData()
    },
    
    handleReset() {
      this.searchData.company_name = ''
      this.searchData.date_range = this.getTodayRange()
      this.currentPage = 1
      this.getTotalData()
    },
    
    handleDateRangeChange(dates) {
      // 当用户选择日期范围后，强制修正结束时间为 23:59:59
      if (dates && dates.length === 2) {
        const endDate = new Date(dates[1])
        endDate.setHours(23, 59, 59, 999)
        this.searchData.date_range = [dates[0], endDate]
      }
    },
    
    handlePageChange(page) {
      this.currentPage = page
      this.getTotalData()
    },
    
    handlePageSizeChange(size) {
      this.pageSize = size
      this.currentPage = 1
      this.getTotalData()
    },
    viewDetail(row) {
      this.detailModal.show = true
      this.detailModal.data = row
      this.detailCurrentPage = 1
      this.getDetailData(row.company_id)
    },
    async getDetailData(companyId) {
      this.detailLoading = true
      try {
        let params = {
          company_id: companyId,
          page: this.detailCurrentPage,
          page_size: this.detailPageSize
        }
        
        // 如果有时间范围，也传递给详情接口
        if (this.searchData.date_range && Array.isArray(this.searchData.date_range) && this.searchData.date_range.length === 2) {
          const startDate = this.searchData.date_range[0]
          const endDate = this.searchData.date_range[1]
          
          // 开始时间：设置为当天的 00:00:00
          const start = new Date(startDate)
          start.setHours(0, 0, 0, 0)
          params.start_date = this.formatDateToString(start)
          
          // 结束时间：强制设置为当天的 23:59:59
          const end = new Date(endDate)
          end.setHours(23, 59, 59, 999)
          params.end_date = this.formatDateToString(end)
        }
        
        let res = await this.$commonFun.postProxy('admin/finance/getRechargeRecord', params)
        this.$commonFun.dealApiResult(res, () => {
          this.detailData = res.data || []
          this.detailTotal = res.count || 0
        })
      } catch (error) {
        console.error('获取充值明细失败:', error)
      } finally {
        this.detailLoading = false
      }
    },
    handleDetailPageChange(page) {
      this.detailCurrentPage = page
      this.getDetailData(this.detailModal.data.company_id)
    },
    handleDetailPageSizeChange(size) {
      this.detailPageSize = size
      this.detailCurrentPage = 1
      this.getDetailData(this.detailModal.data.company_id)
    },
    async handleExport() {
      this.exportLoading = true
      try {
        // 准备请求参数
        let params = {
          page: 1,
          page_size: 10000 // 获取所有数据
        }
        
        // 添加车队名称参数
        if (this.searchData.company_name) {
          params.company_name = this.searchData.company_name.trim()
        }
        
        // 添加时间范围参数
        if (this.searchData.date_range && Array.isArray(this.searchData.date_range) && this.searchData.date_range.length === 2) {
          const startDate = this.searchData.date_range[0]
          const endDate = this.searchData.date_range[1]
          
          // 开始时间：设置为当天的 00:00:00
          const start = new Date(startDate)
          start.setHours(0, 0, 0, 0)
          params.start_date = this.formatDateToString(start)
          
          // 结束时间：强制设置为当天的 23:59:59
          const end = new Date(endDate)
          end.setHours(23, 59, 59, 999)
          params.end_date = this.formatDateToString(end)
        }
        
        // 调用导出接口
        const exportRes = await this.$commonFun.postProxy('admin/finance/exportRechargeRecord', params)
        if (exportRes.code === 200 && exportRes.data && exportRes.data.length > 0) {
          // 直接使用后端返回的数据，不做过滤
          const exportData = exportRes.data
          // 使用 XLSX 库生成 Excel
          const worksheet = XLSX.utils.aoa_to_sheet(exportData)
          const workbook = XLSX.utils.book_new()
          XLSX.utils.book_append_sheet(workbook, worksheet, '充值明细')
          
          // 根据实际列数设置列宽（单位：字符数）
          const colCount = exportData[0] ? exportData[0].length : 0
          const wscols = []
          for (let i = 0; i < colCount; i++) {
            wscols.push({ wch: 20 }) // 默认每列宽度20
          }
          worksheet['!cols'] = wscols
          
          // 生成文件名
          const fileName = `充值明细_${this.formatDateForFilename(new Date())}.xlsx`
          
          // 下载文件
          XLSX.writeFile(workbook, fileName)
          
          this.$Message.success('导出成功')
        } else {
          this.$Message.error('暂无数据可导出')
        }
      } catch (error) {
        console.error('导出失败:', error)
        this.$Message.error('导出失败，请稍后重试')
      } finally {
        this.exportLoading = false
      }
    },
    formatDateForFilename(date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const seconds = String(date.getSeconds()).padStart(2, '0')
      return `${year}${month}${day}${hours}${minutes}${seconds}`
    },
    formatDateToString(date) {
      if (!date) return ''
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const seconds = String(date.getSeconds()).padStart(2, '0')
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    },
    formatDate(dateStr) {
      if (!dateStr) return '-'
      return dateStr.replace(/ /g, '<br>')
    },
    formatDateTime(date, isEndDate = false) {
      if (!date) return ''
      const d = new Date(date)
      const year = d.getFullYear()
      const month = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      const hours = isEndDate ? '23' : String(d.getHours()).padStart(2, '0')
      const minutes = isEndDate ? '59' : String(d.getMinutes()).padStart(2, '0')
      const seconds = isEndDate ? '59' : String(d.getSeconds()).padStart(2, '0')
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    },
    getTodayRange() {
      const today = new Date()
      const startOfDay = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0)
      const endOfDay = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59)
      return [startOfDay, endOfDay]
    }
  },
  mounted() {
    // 设置默认时间范围为今天 00:00:00 到 23:59:59
    this.searchData.date_range = this.getTodayRange()
    this.getTotalData()
  }
}
</script>

<style scoped lang="less">
.page {
  position: relative;
  margin-top: 20px;
  left: 0;
  text-align: right;
}

.stat-card {
  border-radius: 8px;
  overflow: hidden;
  transition: all 0.3s ease;
  
  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
  }
  
  .ivu-card-body {
    padding: 24px;
  }
}

.stat-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.stat-icon {
  width: 70px;
  height: 70px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  
  &.amount-icon {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: #fff;
  }
  
  &.count-icon {
    background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
    color: #fff;
  }
  
  &.company-icon {
    background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
    color: #fff;
  }
}

.stat-info {
  flex: 1;
  margin-left: 20px;
}

.stat-label {
  font-size: 14px;
  color: #808695;
  margin-bottom: 8px;
  font-weight: 500;
}

.stat-value {
  font-size: 32px;
  font-weight: bold;
  color: #17233d;
  line-height: 1;
  
  &.highlight {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }
}

.detail-header {
  margin-bottom: 20px;
  padding: 16px;
  background: #f8f9fa;
  border-radius: 6px;
}

.header-row {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  
  &:last-child {
    margin-bottom: 0;
  }
  
  .header-label {
    width: 100px;
    color: #606266;
    font-size: 14px;
    font-weight: 500;
  }
  
  .header-value {
    flex: 1;
    color: #17233d;
    font-size: 14px;
    
    &.highlight {
      color: #19be6b;
      font-weight: bold;
      font-size: 18px;
    }
  }
}

.drawer-footer {
  margin-top: 20px;
  text-align: right;
  padding-top: 16px;
  border-top: 1px solid #e8eaec;
}

.detail-content {
  padding: 10px 0;
}

.detail-row {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  padding: 12px;
  background: #f8f9fa;
  border-radius: 4px;
  
  &:last-child {
    margin-bottom: 0;
  }
  
  .detail-label {
    width: 100px;
    color: #606266;
    font-size: 14px;
    font-weight: 500;
  }
  
  .detail-value {
    flex: 1;
    color: #17233d;
    font-size: 14px;
    
    &.highlight {
      color: #19be6b;
      font-weight: bold;
      font-size: 18px;
    }
  }
}

.data-card {
  cursor: pointer;
  transition: all 0.3s;
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  }
  
  p[slot="title"] {
    font-size: 14px;
    color: #808695;
    margin-bottom: 10px;
  }
  
  .data-value {
    font-size: 28px;
    font-weight: bold;
    color: #17233d;
    line-height: 1.5;
    
    &.highlight {
      color: #19be6b;
    }
    
    &.warning {
      color: #ff9900;
    }
  }
}
</style>
